export default {
  dbl_model_management_title: 'Model Management Center',
  dbl_model_management_create_model: 'Create New Model',
  dbl_model_management_search_placeholder: 'Search by model name,field or description',
  dbl_model_management_name: 'Name',
  dbl_model_management_description: 'Description',
  dbl_model_management_deployment_stage: 'Deployment Stage',
  dbl_model_management_publish_version: 'Published Version',
  dbl_model_management_creator: 'Creator',
  dbl_model_management_update_time: 'Update Time',
  dbl_model_management_action: 'Actions',
  dbl_model_management_detail: 'Detail',
  dbl_model_management_access: 'Access',
  dbl_model_management_edit: 'Edit',
  dbl_model_management_delete: 'Delete',
  dbl_model_management_more: 'More',
  dbl_model_management_official_user_guide: 'User Guide',
  dbl_model_management_official_documentation: 'Official Documentation',
  dbl_model_management_quick_start: 'Quick Start',
  dbl_model_management_select_schema: 'Select Schema',
  dbl_model_management_select_tables: 'Select Tables',
  dbl_model_management_tables: 'Tables',
  dbl_model_management_set_up_dimension_metric: 'Set up Dimension&Metric',
  dbl_model_management_test_publish: 'Test & Publish',
  dbl_model_management_test: 'Test',
  dbl_model_management_publish: 'Publish',
  dbl_model_management_select_database: 'Select Database',
  dbl_model_management_save_all: 'Save All',
  dbl_model_management_draft: 'Draft',
  dbl_model_management_tested: 'Tested',
  dbl_model_management_published: 'Published',
  dbl_model_management_published_version: 'Published Version',
  dbl_model_management_unpublish: 'Unpublish',
  dbl_model_management_total: "Total {total} Items",
  dbl_model_management_delete_success: 'Delete Success',
  dbl_model_management_delete_failed: 'Delete Failed',
  dbl_model_management_publish_success: 'Publish Success',
  dbl_model_management_publish_failed: 'Publish Failed',
  dbl_model_management_unpublish_success: 'Unpublish Success',
  dbl_model_management_unpublish_failed: 'Unpublish Failed',
  dbl_model_management_test_success: 'Test Success',
  dbl_model_management_test_failed: 'Test Failed',

  dbl_model_management_create_model_title: 'Create Data Model',
  dbl_model_management_create_model_previous_step: 'Prev Step',
  dbl_model_management_create_model_next_step: 'Next Step',
  dbl_model_management_create_model_list: 'Model List',
  dbl_model_management_create_model_save: 'Save',
  dbl_model_management_create_model_save_all: 'Save All',
  dbl_model_management_create_model_save_success: '{name} Save Success',
  dbl_model_management_create_model_save_failed: '{name} Save Failed',
  dbl_model_management_create_model_save_failed_hint:
    'Failed to save draft. Check YAML syntax, database/table, and field config, then try again.',
  dbl_model_management_create_model_generate_success:
    '{name} YAML Generated Successfully',
  dbl_model_management_create_model_generate_failed:
    '{name} YAML Generation Failed',
  dbl_model_management_create_model_generate_failed_hint:
    'Failed to generate YAML. Check database/table and field config, then try again.',
  dbl_model_management_yaml_generate_detail_title: 'Generation failure details',
  dbl_model_management_yaml_save_detail_title: 'Save failure details',
  dbl_model_management_yaml_save_batch_long_summary:
    'Save did not succeed ({count} item(s)). {preview}',
  dbl_model_management_create_model_publish_success: '{name} Publish Success',
  dbl_model_management_create_model_publish_failed: '{name} Publish Failed',
  dbl_model_management_create_model_duplicate_name: 'Duplicate name',
  dbl_model_management_create_model_name_error: 'Support underline, English, and numbers',
  dbl_model_management_create_model_testing: 'Testing...',
  dbl_model_management_create_model_testing_info: 'Testing in progress, please wait...',
  dbl_model_management_create_model_tested_info: '{successCount} models passed testing,while {errorCount} did not.',
  dbl_model_management_create_model_tested_info_success: '{successCount} models passed the test',
  dbl_model_management_create_model_tested_info_error: '{errorCount} models did not pass the test',
  dbl_model_management_create_model_leave_title: 'Leave the current page?',
  dbl_model_management_create_model_leave_des: "The current page has not been saved. Leaving will result in the loss of all content.",
  dbl_model_management_sure_to_delete_model_title: 'Delete Model',
  dbl_model_management_sure_to_delete_model_message: "Delete {name}? Deletion is irreversible, please proceed with caution.",
  dbl_model_management_publish_bubble: 'Please conduct testing first',
  dbl_model_management_sure_to_publish_model_title: 'Publish',
  dbl_model_management_sure_to_publish_model_message: 'The {successCount} passing models will be published.{br}The {errorCount} non-passing models will be saved as drafts, and you may publish them after adjustments.',
  dbl_model_management_leave_model_title: 'Save model?',
  dbl_model_management_leave_model_desc: 'The model has not been saved yet, and leaving it will result in the loss of all content.',

  dbl_model_management_yaml_test_view_detail: 'View details',
  dbl_model_management_yaml_test_detail_title: 'Test failure details',
  dbl_model_management_yaml_test_copy: 'Copy all',
  dbl_model_management_yaml_test_copy_success: 'Copied to clipboard',
  dbl_model_management_yaml_test_copy_failed: 'Copy failed; select the text manually',
  dbl_model_management_yaml_test_error_code: 'Error code: {code}',
  dbl_model_management_yaml_test_unnamed_model: 'Unnamed model',
  dbl_model_management_yaml_test_batch_long_summary:
    '{count} model(s) did not pass the test. {preview}',
  dbl_model_management_list_refresh_failed:
    'Failed to refresh the list or filters. Please try again later.',
  dbl_model_management_mcp_address: 'MCP service address',  
  dbl_model_agent_create_title: 'Create Data Model',
  dbl_model_agent_create_leave_save_and_leave: 'Save & Leave',
  dbl_model_agent_edit_title: 'Edit Data Model',
  dbl_model_agent_create_step_select_tables: 'Select Tables',
  dbl_model_agent_create_step_field_config: 'Field Configuration',
  dbl_model_agent_create_step_yaml: 'Generate YAML',
  dbl_model_agent_create_step_test_publish: 'Test & Publish',
  dbl_model_agent_create_select_fields: 'Please select fields',
  dbl_model_agent_create_fields: 'Fields',
  dbl_model_agent_field_config_need_tables:
    'Please select database, schema, and at least one table first.',
  dbl_model_agent_field_config_empty_catalog:
    'No fields were returned. Check your tables or try again later.',
  dbl_model_agent_step2_sec_dimensions: 'Dimensions',
  dbl_model_agent_step2_sec_measures: 'Measures',
  dbl_model_agent_step2_add_dimension: 'Add dimension',
  dbl_model_agent_step2_add_measure: 'Add measure',
  dbl_model_agent_step2_kind_dimension: 'Dimension',
  dbl_model_agent_step2_kind_metric: 'Measure',
  dbl_model_agent_step2_col_source: 'Field name',
  dbl_model_agent_step2_col_kind: 'Type',
  dbl_model_agent_step2_col_display: 'Display name',
  dbl_model_agent_step2_col_row_select: 'Select',
  dbl_model_agent_step2_select_all: 'Select all',
  dbl_model_agent_step2_col_name_zh: 'Chinese name',
  dbl_model_agent_step2_col_name_en: 'English name',
  dbl_model_agent_step2_col_data_type: 'Data type',
  dbl_model_agent_step2_col_agg_type: 'Measure type',
  dbl_model_agent_step2_col_sql: 'SQL',
  dbl_model_agent_step2_col_desc: 'Description',
  dbl_model_agent_step2_col_sample: 'Sample values',
  dbl_model_agent_step2_col_dim_summary: 'Dim summary',
  dbl_model_agent_step2_col_dim_table: 'Dim table',
  dbl_model_agent_step2_col_dim_join_column: 'Join column',
  dbl_model_agent_step2_col_common_query: 'Common query',
  dbl_model_agent_step2_placeholder_common_query: 'Common query description',
  dbl_model_agent_step2_inline_dim_heading: 'Add custom dimension',
  dbl_model_agent_step2_inline_meas_heading: 'Add custom measure',
  dbl_model_agent_step2_inline_sql_placeholder_dim: '{CUBE}.field or expression',
  dbl_model_agent_step2_inline_sql_placeholder_meas:
    '{CUBE}.field or aggregate expression',
  dbl_model_agent_step2_placeholder_dim_display: 'Custom dimension 1 (auto)',
  dbl_model_agent_step2_placeholder_meas_display: 'Custom measure 1 (auto)',
  dbl_model_agent_step2_placeholder_sample_dim: '["255","global"]',
  dbl_model_agent_step2_placeholder_dim_summary: '255/global',
  dbl_model_agent_step2_placeholder_dim_table: 'Dimension table',
  dbl_model_agent_step2_placeholder_dim_join: 'Join column on dim table',
  dbl_model_agent_step2_placeholder_filters: 'case when…',
  dbl_model_agent_step2_placeholder_name_zh: 'Chinese name',
  dbl_model_agent_step2_placeholder_name_en: 'English name',
  dbl_model_agent_step2_placeholder_description: 'Field description',
  dbl_model_agent_step2_option_unset: 'Not set',
  dbl_model_agent_field_config_dim_data_type_time: 'Time',
  dbl_model_agent_field_config_dim_data_type_string: 'String',
  dbl_model_agent_field_config_dim_data_type_number: 'Number',
  dbl_model_agent_field_config_dim_data_type_boolean: 'Boolean',
  dbl_model_agent_field_config_dim_data_type_geo: 'Geo',
  dbl_model_agent_field_config_dim_data_type_switch: 'Switch (enum)',
  dbl_model_agent_field_config_measure_agg_sum: 'Sum',
  dbl_model_agent_field_config_measure_agg_count: 'Count',
  dbl_model_agent_field_config_measure_agg_count_distinct: 'Count distinct',
  dbl_model_agent_field_config_measure_agg_avg: 'Average',
  dbl_model_agent_field_config_measure_agg_min: 'Minimum',
  dbl_model_agent_field_config_measure_agg_max: 'Maximum',
  dbl_model_agent_field_config_measure_agg_number: 'Number (generic)',
  dbl_model_agent_step2_option_format_percent: 'Percent',
  dbl_model_agent_step2_option_granularity_hour: 'Hour',
  dbl_model_agent_step2_option_granularity_day: 'Day',
  dbl_model_agent_step2_option_granularity_month: 'Month',
  dbl_model_agent_step2_col_format: 'Format',
  dbl_model_agent_step2_col_granularity: 'Granularity',
  dbl_model_agent_step2_col_filters: 'Filters',
  dbl_model_agent_step2_col_actions: 'Actions',
  dbl_model_agent_step2_remove: 'Remove',
  dbl_model_agent_step2_custom_tag: 'Custom',
  dbl_model_agent_step2_empty_dim:
    'No dimensions yet. Select fields above or add a custom dimension.',
  dbl_model_agent_step2_empty_meas:
    'No measures yet. Select fields above or add a custom measure.',
  dbl_model_agent_step2_add_dim_title: 'Add custom dimension',
  dbl_model_agent_step2_add_meas_title: 'Add custom measure',
  dbl_model_agent_step2_modal_cancel: 'Cancel',
  dbl_model_agent_step2_modal_confirm: 'Add',
  dbl_model_agent_step2_notify_complete_dim: 'Please complete the dimension',
  dbl_model_agent_step2_notify_complete_meas: 'Please complete the measure',
  dbl_model_agent_step2_notify_required_fields: 'Please complete all required fields',
  dbl_model_agent_yaml_file_label: 'YAML configuration',
  dbl_model_agent_yaml_status_generating: 'Generating…',
  dbl_model_agent_yaml_status_ready: 'Ready — you can edit freely',
  dbl_model_agent_yaml_status_idle: 'No content yet — click Regenerate',
  dbl_model_agent_yaml_status_error:
    'Generation failed. Check your configuration or try again later.',
  dbl_model_agent_yaml_regenerate: 'Regenerate',
  dbl_model_agent_yaml_regenerate_confirm:
    'Regenerate YAML from the current table and field selection? Unsaved edits in the editor will be overwritten.',
  dbl_model_agent_summary_tables: 'Tables',
  dbl_model_agent_summary_dimensions: 'Dimensions',
  dbl_model_agent_summary_measures: 'Measures',
  dbl_model_agent_summary_count_unit: '{n} selected',
  dbl_model_agent_step4_summary_cube_name: 'Cube name',
  dbl_model_agent_step4_summary_source_table: 'Source table',
  dbl_model_agent_step4_summary_dim_fields: 'Dimension fields',
  dbl_model_agent_step4_summary_meas_fields: 'Measure fields',
  dbl_model_agent_step4_test_bar_label: 'Test status:',
  dbl_model_agent_step4_test_status_idle: 'Pending',
  dbl_model_agent_step4_test_status_running: 'Running…',
  dbl_model_agent_step4_test_status_passed: 'All passed ✓',
  dbl_model_agent_step4_test_status_failed: 'Issues found ×',
  dbl_model_agent_step4_run_all_tests: '▶ Run all tests',
  dbl_model_agent_step4_retest: 'Re-run tests',
  dbl_model_agent_step4_test_pass_line: '{name} passed ✓',
  dbl_model_agent_step4_test_running_line: '{name} — testing',
  dbl_model_agent_step4_test_yaml_title: 'YAML syntax check',
  dbl_model_agent_step4_test_yaml_desc:
    'Validate YAML structure and required fields (name, sql_table, data_source)',
  dbl_model_agent_step4_test_sample_title: 'Sample query test',
  dbl_model_agent_step4_test_sample_desc:
    'Run SQL and verify the result shape matches the schema',
  dbl_model_agent_step4_sample_skipped: 'Sample query test was skipped',
  dbl_model_agent_step4_sample_time_dimension: 'Time dimension',
  dbl_model_agent_step4_sample_date_range: 'Date range',
  dbl_model_agent_step4_sample_measures: 'Measures tested',
  dbl_model_agent_step4_sample_total: 'Rows returned',
  dbl_model_agent_step4_sample_query_sql: 'Query SQL',
  dbl_model_agent_step4_pub_title: '🎉 All tests passed — ready to publish!',
  dbl_model_agent_step4_pub_desc:
    'Configuration passed all automated checks and is safe to publish to DataLab.',
  dbl_model_agent_step4_publish: '🚀 Publish',
  dbl_model_agent_step4_save_draft: '💾 Save as draft',
};